import { render } from "./small.vue?vue&type=template&id=2e1581bc&ts=true"
import script from "./small.vue?vue&type=script&lang=ts"
export * from "./small.vue?vue&type=script&lang=ts"

import "./small.vue?vue&type=style&index=0&id=2e1581bc&lang=scss"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__